export default {
  title: 'Мой профиль',
  fio: 'Фамилия, имя и отчество',
  fioDescription: 'Для операций по квартирам и консультаций',
  firstName: 'Укажите имя',
  lastName: 'Укажите фамилию',
  fillTheField: 'Заполните поле',
  patronymicName: 'Укажите отчество',
  birthDateAndSex: 'Дата рождения и пол',
  birthDateAndSexDescription: 'Введите вручную или выберите из списка',
  selectSex: 'Введите пол',
  selectBirthday: 'Выберите дату рождения',
  contacts: 'Контактные данные',
  contactsDescription: 'Для уведомлений и получения документов',
  documents: 'Документы',
  email: 'Электронная почта',
  phoneDesc: 'Чтобы изменить телефон, позвоните нам ',
  emailDesc1: 'Чтобы изменить электронную почту, позвоните нам ',
  emailDesc2: ' либо напишите на почту ',
  save: 'Сохранить',
  pageDescription: {
    profileIsEmpty: 'Вы сможете загрузить документы после заполнения \n профиля. Они нужны для покупки квартиры',
    docsIsNotUploaded:
      'Для покупки квартиры нужно загрузить документы. \n После их загрузки информация меняется только \n через техподдержку',
    docsIsUploaded:
      'Для покупки квартиры нужно загрузить документы. \n После их загрузки информация меняется только \n через техподдержку',
    isVerified: 'Все данные для покупки квартиры заполнены. Чтобы изменить их, ',
  },
  documentsTitle: {
    profileIsEmpty: 'Мои документы',
    docsIsNotUploaded: 'Мои документы',
    docsIsUploaded: 'Документы на проверке',
    isVerified: 'Документы проверены',
  },
  documentsDescription: {
    profileIsEmpty: 'Сначала заполните профиль',
    docsIsNotUploaded: 'Паспорт, СНИЛС и ИНН',
    docsIsUploaded: 'При необходимости, можете ',
    isVerified: 'Паспорт, СНИЛС и ИНН',
  },
  passportData: {
    passport: 'Паспортные данные',
    snils: 'СНИЛС',
    inn: 'ИНН',
    birthPlace: 'Место рождения',
    series: 'Серия',
    number: 'Номер',
    date: 'Дата выдачи',
    provider: 'Кем выдан',
    address: 'Адрес регистрации',
    code: 'Код подразделения',
  },
  sendDocuments: 'Отправить документы',
  loadDocument: 'загрузить документы',
  loadDocumentEndText: ' повторно',
  requestSupport: 'обратитесь в поддержку,',
  descriptionEnd: ' или позвоните нам +7 (843) 567-23-71',
  nonChangesDataNotification: 'Вы не внесли никаких изменений 🤔',
};
